<div class="prepaid-table-container">
  @if (!loading) {
    <div class="table-scroll-wrapper">
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-mdc-table"
        data-testid="prepaid-wash-books-table"
      >
        <!-- ID Column -->
        <ng-container matColumnDef="bookCode">
          <th mat-header-cell *matHeaderCellDef style="min-width: 110px">ID</th>
          <td mat-cell *matCellDef="let book" class="p5 text-semibold book-id">{{ book.slug }}</td>
        </ng-container>

        <!-- Package Name Column -->
        <ng-container matColumnDef="packageName">
          <th mat-header-cell *matHeaderCellDef style="min-width: 280px">Prepaid Package</th>
          <td mat-cell *matCellDef="let book">
            <div class="package-name-cell">
              <span class="package-name p3 text-semibold">{{ book.name }}</span>
              <span class="created-date p7"
                >Created on {{ book.created_at | date: 'd MMMM, y' }}</span
              >
            </div>
          </td>
        </ng-container>

        <!-- Wash Configs Column -->
        <ng-container matColumnDef="washConfigs">
          <th mat-header-cell *matHeaderCellDef style="min-width: 220px">Wash Configs</th>
          <td mat-cell *matCellDef="let book">
            <div class="wash-types p7">
              @for (item of book.items; track item.id) {
                <span class="wash-type-tag" [ngClass]="washChipClass(item.type)">
                  {{ itemChip(item) }}
                </span>
              }
            </div>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px">Status</th>
          <td mat-cell *matCellDef="let book">
            <span [class.status-active]="book.status" [class.status-inactive]="!book.status">
              {{ book.status ? 'Active' : 'Inactive' }}
            </span>
          </td>
        </ng-container>

        <!-- Price Column -->
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px">List Price</th>
          <td mat-cell *matCellDef="let book" class="p5">
            {{ toNumber(book.selling_price) | currency }}
          </td>
        </ng-container>

        <!-- Orders Column -->
        <ng-container matColumnDef="orders">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px">Total Orders</th>
          <td mat-cell *matCellDef="let book" class="p5">{{ book.number_of_purchased }}</td>
        </ng-container>

        <!-- Redemptions Column -->
        <ng-container matColumnDef="redemptions">
          <th mat-header-cell *matHeaderCellDef style="min-width: 150px">Pending Redemptions</th>
          <td mat-cell *matCellDef="let book" class="p5">{{ toNumber(book.total_redeemed) }}</td>
        </ng-container>

        <!-- Last Updated Column -->
        <ng-container matColumnDef="lastUpdated">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px">Last Updated</th>
          <td mat-cell *matCellDef="let book" class="p5">
            {{ book.updated_at | date: 'd MMM, y' }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px">Actions</th>
          <td mat-cell *matCellDef="let book">
            <app-package-row-actions
              [testId]="'prepaid-wash-book-row-actions-' + book.id"
              [items]="rowActionItems"
              (menuOpened)="currentBook = book"
              (action)="onRowAction($event)"
            />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [attr.data-testid]="'prepaid-wash-books-table-row-' + row.id"
        ></tr>
      </table>
    </div>
  }
</div>

@if (showDeleteModal) {
  <app-delete-prepaid-wash-book-modal
    [book]="bookToDelete"
    [loading]="isDeleting"
    (close)="onCloseDeleteModal()"
    (confirm)="onConfirmDelete($event)"
  />
}
